import { useState } from 'react';

import { fetchAirdropClaimRecord } from '@api/airdrop';
import type {
  AirdropClaimRecordType
} from '@api/index';

export const useMePaging = () => {
  const [historyData, setHistoryData] = useState<
    AirdropClaimRecordType
  >();

  const fetchHistoryData = async () => {
    const data = await fetchAirdropClaimRecord({ limit: 10, offset: 0 });
    setHistoryData(data.obj);
  }

  return { historyData, fetchHistoryData };
};
